import accountManageStore from 'store/account-manage';
import userStore from 'store/user';

class GTM {
  constructor() {
    (window as any).dataLayer = (window as any).dataLayer || [];
  }

  track(eventName: string, eventParams?: { [key: string]: any }) {
    (window as any).dataLayer.push(
      Object.assign(
        { event: eventName },
        {
          accountId: accountManageStore.userInfo?.id,
          accountType: userStore.userProfile.type,
          merchantId: userStore.userProfile.merchantId,
        },
        eventParams,
      ),
    );
  }
}

export default new GTM();
